import { Column } from '@ru-digital-assets/ui-component/dist/stories/table';
import { ICompanyVerificationInfo } from 'constants/company-verification';
import CompanyVerificationStatus from './CompanyVerificationStatus';

export const getColumns = (): Column<ICompanyVerificationInfo>[] => {
  return [
    {
      title: 'Лицо',
      name: 'company',
      headerStyle: {
        width: '42.5%',
      },
      dataGetter: (data) => data.organizationName,
    },
    {
      title: 'Представитель',
      name: 'user',
      headerStyle: {
        width: '42.5%',
      },
      dataGetter: (data) => data.initiatorFullName,
    },
    {
      title: '',
      name: 'status',
      headerStyle: {
        width: '15%',
        borderLeft: 0,
      },
      dataGetter: (data) => data,
      Component: ({ data }: { data: ICompanyVerificationInfo }) => {
        return (
          <div className="flex justify-end">
            <CompanyVerificationStatus verified={data.verified} />
          </div>
        );
      },
    },
  ];
};
